import * as React from 'react';
import styled, { keyframes } from 'styled-components';

interface FadeUpAnimationProps {
    children: React.ReactNode;
    delay?: number;
    style?: React.CSSProperties;
}

const fadeUp = keyframes`
    from {
        transform: translateY(24px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

const AnimatedDiv = styled.div<{ $delay: number }>`
    animation: ${fadeUp} 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
    animation-delay: ${({ $delay }) => $delay}ms;
    opacity: 0;
`;

export const FadeUpAnimation: React.FC<FadeUpAnimationProps> = ({
    children,
    delay = 0,
}) => {
    return (
        <AnimatedDiv $delay={delay}>
            {children}
        </AnimatedDiv>
    );
};
